import React, {useEffect, useState} from "react";
import {Button, Card, Col, Row, Spinner} from "reactstrap";
import useApiCallService from "../../Common/Helpers/ApiCall";
import ResponseReimbursement from "../Models/Response/ResponseReimbursement";
import ResponseReimbursementFixed from "../Models/Response/ResponseReimbursementFixed";
import ResponseReimbursementMileage from "../Models/Response/ResponseReimbursementMileage";
import ResponseReimbursementExpense from "../Models/Response/ResponseReimbursementExpense";
import {useNavigate, useLocation} from "react-router-dom";
import {CustomButton} from "../../Common/Components/Button/CustomButton";
import { REPORT_PROCEEDING_PATHS} from "../../config";
import ResponseUserModel from "../../User/Models/Response/ResponseUserModel";
import {useTranslation} from "react-i18next";
import {CustomReimbursementView} from "../Components/CustomReimbursementView";
import {CustomReimbursementFixedView} from "../Components/CustomReimbursementFixedView";
import {CustomReimbursementMileageView} from "../Components/CustomReimbursementMileageView";
import {CustomReimbursementExpenseView} from "../Components/CustomReimbursementExpenseView";
import $ from "jquery";
import { ChangeDateFormat } from "../../Common/Helpers/ChangeDateFormat";
import { CustomReimbursementParticipantsView } from "../Components/CustomReimbursementParticipantsView";
import { CustomReimbursementAttachmentView } from "../Components/CustomReimbursementAttachmentView";
import { CustomReimbursementCommentView } from "../Components/CustomReimbursementCommentView";
import { useHeader } from "../../Auth/Components/Nav/HeaderContext";
import { CheckMobile } from "../../AppSystem/Helpers/CheckMobile";
import { ToCustomDecimal } from "../../AppSystem/Helpers/ToCustomDecimal";

const ReportProceedingInfo = ({ id: propId = null, userId: propUserId = null, onClose = null }) => {
    const { t } = useTranslation()
    const { ApiCall } = useApiCallService();
    const navigate = useNavigate();
    const location = useLocation();
    const isMobile = CheckMobile(998);
    const { setPageTitle, setPageTitleKey, setOnBack } = useHeader();
    const isEmbeddedInSlidePanel = propId !== null && typeof onClose === "function";

    useEffect(() => {
        if (isEmbeddedInSlidePanel) {
            return undefined;
        }

        setPageTitle(t('reimbursement.reportProcessing'));
        setPageTitleKey('reimbursement.reportProcessing');
        setOnBack(() => {
            if (location.state && location.state.returnTo) {
                navigate(location.state.returnTo);
            } else {
                navigate(REPORT_PROCEEDING_PATHS.REPORT_PROCEEDING_LIST);
            }
        });
        return () => { setPageTitle(''); setPageTitleKey(''); setOnBack(null); };
    }, [t, isEmbeddedInSlidePanel, location.state, navigate, setOnBack, setPageTitle, setPageTitleKey]);

    const userId = propUserId || location.state?.userId || null;

    const [user, setUser] = useState(new ResponseUserModel());
    const [reimbursement, setReimbursement] = useState(new ResponseReimbursement());
    const [reimbursementFixed, setReimbursementFixed] = useState(new ResponseReimbursementFixed());
    const [reimbursementMileage, setReimbursementMileage] = useState(new ResponseReimbursementMileage());
    const [reimbursementExpense, setReimbursementExpense] = useState(new ResponseReimbursementExpense());
    const [duplicateReimbursement, setDuplicateReimbursement] = useState(null);

    const urlParams = new URLSearchParams(window.location.search);
    const id = propId ?? urlParams.get('id') ?? "";

    // GET REIMBURSEMENT
    useEffect(() => {
        if (id !== "") {
            const handleApiResponse = (apiResponse) => {
                setReimbursement(apiResponse);
                setReimbursementFixed(apiResponse.fixeds);
                setReimbursementMileage(apiResponse.mileage);
                setReimbursementExpense(apiResponse.expenses);
            };
            const fetchData = async () => {
                try {
                    const apiCallOptions = {
                        method: "get",
                        url: `/reimbursement?id=${id}` + (userId && userId !== "" && userId !== "undefined" ? `&userId=${userId}` : "")
                    };
                    await ApiCall(apiCallOptions, handleApiResponse);
                } catch (error) {
                    console.log('error', error);
                }
            };
            fetchData();
        }
    }, []);

    // GET USER
    useEffect(() => {
        if (reimbursement.userId !== "") {
            const handleApiResponse = (apiResponseUser) => {
                setUser(apiResponseUser);
            };
            const fetchData = async () => {
                try {
                    const apiCallOptions = {
                        method: "get",
                        url: `/user?id=${reimbursement.userId}`
                    };
                    await ApiCall(apiCallOptions, handleApiResponse);
                } catch (error) {
                    console.log('error', error);
                }
            };
            fetchData();
        }
    }, [reimbursement]);

    // HANDLE DUPLICATE
    const HandleDuplicate = async () => {
        $("#duplicateButton").prop("disabled", true);
        $("#spinner").removeClass("d-none");
        try {
            const apiCallOptions = {
                method: "post",
                url: `/reimbursement/duplicate`,
                data: {
                    id: reimbursement.id
                }
            };
            await ApiCall(apiCallOptions, setDuplicateReimbursement);
        } catch (error) {
            console.log('error', error);
        }
    }

    // DUPLICATE REDIRECT
    useEffect(() => {
        if (duplicateReimbursement !== null && duplicateReimbursement.id !== "") {
            $("#duplicateButton").prop("disabled", false);
            navigate(`${REPORT_PROCEEDING_PATHS.REPORT_PROCEEDING}?id=${duplicateReimbursement.id}`);
        } else {
            $("#duplicateButton").prop("disabled", false);
            $("#spinner").addClass("d-none");
        }
    }, [duplicateReimbursement]);

    const handleBackNavigation = () => {
        if (onClose) {
            onClose();
        } else if (location.state && location.state.returnTo) {
            navigate(location.state.returnTo);
        } else {
            navigate(REPORT_PROCEEDING_PATHS.REPORT_PROCEEDING_LIST);
        }
    };

    
    const badge = (() => {
        switch (reimbursement?.status) {
        case "Godkänd":
            return { text: "Godkänd för utbetalning", style: { background: "#D9F1E6", color: "#157553" } };
        case "Utbetald":
            return { text: "Utbetald", style: { background: "#D9F1E6", color: "#157553" } };
        case "Nekad":
            return { text: "Nekad", style: { background: "#F8DCDC", color: "#C0392B" } };
        default:
            return null;
        }
    })();

    return (
        <Col lg={12} className="p-0">
            {!isMobile && (
                <Row>
                    <Col lg={1} className="reimbursement-back-wrap">
                        <CustomButton
                            text={t('button.back')}
                            icon={'bx bx-chevron-left'}
                            buttonSize={'small'}
                            customClasses={'mb-3 ms-3'}
                            onClick={handleBackNavigation}
                        />
                    </Col>
                </Row>
            )}
            <Row className={`${isMobile && isEmbeddedInSlidePanel ? 'pb-0' : 'pb-5'} d-flex justify-content-center reimbursement-proceeding-row`}>
                {reimbursement !== null && reimbursement.id !== "" ?
                    <>
                        <Col xs={12} lg={6}>
                            <Card className="reimbursement-proceeding-card position-relative">
                                {/* {reimbursement.visualId !== "" ?
                                    <div className="position-absolute end-0 mt-4 me-4 top-0 fs-5">{reimbursement.visualId}</div>
                                : ""} */}
                                
                                <div className="reimbursement-summary-header">
                                    <h3 className="reimbursement-summary-title rokkitt-font">Sammanfattning</h3>
                                    {badge && (
                                    <div className="reimbursement-status-badge" style={badge.style}>
                                        {badge.text}
                                    </div>
                                    )}
                                </div>

                                <Row>
                                    {reimbursement.approvedDeniedByName && reimbursement.approvedDeniedByName !== "" && (reimbursement.status === "Nekad" || reimbursement.status === "Godkänd" || reimbursement.status === "Utbetald") ? (
                                        <Col xs={12} lg={6}>
                                            <Card className="reimbursement-section-card">
                                                <div className="reimbursement-section-subtitle">{t("button.info")}</div>
                                                <Row>

                                                    <Col lg={12}>
                                                        <Card className="bg-card-grey p-3">
                                                            <div className="reimbursement-field-label">{t("modelLabel.approvedDeniedByName")}</div>
                                                            <div className="reimbursement-field-value">{reimbursement.approvedDeniedByName}</div>

                                                            {reimbursement.reason ? (
                                                                <>
                                                                    <div className="reimbursement-divider" style={{ margin: "12px 0" }} />
                                                                    <div className="reimbursement-field-label">{t("modelLabel.reason")}</div>
                                                                    <div className="reimbursement-field-value" style={{ fontWeight: 700 }}>
                                                                        {reimbursement.reason}
                                                                    </div>
                                                                </>
                                                            ) : null}
                                                        </Card>
                                                    </Col>

                                                    {!reimbursement.newReimbursementId && reimbursement.status === "Nekad" ? (
                                                        <Col lg={12} className="text-center mt-3">
                                                            {t("reimbursement.deniedMessage")}
                                                            <br />
                                                            <div id="spinner" className="d-none">
                                                                {t("validationMessage.sendDenyForm")}{" "}
                                                                <Spinner color="success" className="me-3" />
                                                            </div>
                                                            <Button
                                                                id="duplicateButton"
                                                                className="bg-green-light text-green border-0"
                                                                onClick={() => {
                                                                    HandleDuplicate();
                                                                }}
                                                            >
                                                                {t("button.create")}
                                                            </Button>
                                                        </Col>
                                                    ) : null}

                                                    {reimbursement.status === "Utbetald" ? (
                                                        <Col lg={12} className="mt-3">
                                                            <div className="reimbursement-section-subtitle">{t("attest.paymentInformation")}</div>
                                                            <Card className="bg-card-grey p-3">
                                                                <Row>
                                                                    <Col>
                                                                        <div className="reimbursement-field-label">{t("attest.recipientAccount")}</div>
                                                                        <div className="reimbursement-field-value">{reimbursement.recipientAccount}</div>
                                                                    </Col>
                                                                    <Col>
                                                                        <div className="reimbursement-field-label">{t("attest.paidDateTime")}</div>
                                                                        <div className="reimbursement-field-value">
                                                                            {ChangeDateFormat("dateTime", reimbursement.paidDateTime)}
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </Card>
                                                        </Col>
                                                    ) : null}
                                                </Row>
                                            </Card>
                                        </Col>
                                    ) : (
                                        ""
                                    )}

                                    <Col lg={12}>
                                        <CustomReimbursementView data={reimbursement} isSlidePanel={true}/>
                                    </Col>

                                    {Array.isArray(reimbursementFixed) && reimbursementFixed.length > 0 ?
                                        <Col lg={12}>
                                            <CustomReimbursementFixedView data={reimbursementFixed}/>
                                        </Col>
                                    : ""}

                                    {reimbursementMileage && reimbursementMileage.id !== "" ?
                                        <Col lg={12}>
                                            <CustomReimbursementMileageView data={reimbursementMileage}/>
                                        </Col>
                                    : ""}

                                    {Array.isArray(reimbursementExpense) && reimbursementExpense.length > 0 ?
                                        <Col lg={12}>
                                            <CustomReimbursementExpenseView
                                                data={reimbursementExpense}
                                                participantsNode={
                                                    <CustomReimbursementParticipantsView
                                                        data={reimbursementExpense}
                                                        embedded={true}
                                                    />
                                                }
                                                attachmentsNode={
                                                    reimbursement.attachments?.fileList?.length > 0 ? (
                                                        <CustomReimbursementAttachmentView
                                                            dataFile={reimbursement.attachments.fileList}
                                                            embedded={true}
                                                        />
                                                    ) : null
                                                }
                                                commentNode={
                                                    reimbursement.attachments?.commentList?.length > 0 ? (
                                                        <CustomReimbursementCommentView
                                                            dataComment={reimbursement.attachments.commentList}
                                                            embedded={true}
                                                        />
                                                    ) : null
                                                }
                                            />
                                        </Col>
                                    : ""}
                                </Row>

                                <div className="reimbursement-footer">
                                    <div className="reimbursement-footer-total-row">
                                        <div className="reimbursement-footer-total-label">{t("modelLabel.total")}:</div>
                                            <div className="reimbursement-footer-total-amount">
                                            {ToCustomDecimal(reimbursement?.amount ?? 0)} kr
                                        </div>
                                    </div>

                                    <Button className="reimbursement-back-button" onClick={handleBackNavigation}>
                                        {t('button.back')}
                                    </Button>
                                </div>
                            </Card>
                        </Col>
                    </>
                    : ""}
            </Row>
        </Col>
    );
};

export default ReportProceedingInfo;